import { render, staticRenderFns } from "./projectCost.vue?vue&type=template&id=598edb38&scoped=true&"
import script from "./projectCost.vue?vue&type=script&lang=js&"
export * from "./projectCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598edb38",
  null
  
)

export default component.exports